import { UserId, UserProfile } from '@beelday/common'
import { compact, keyBy } from 'lodash'
import { useMemo } from 'react'
import { useProfilesFor } from 'users/redux'
import useFetchMissingProfiles from 'users/use-fetch-missing-profiles'

/**
 * The profiles of these people by id. Those the app does not know yet are
 * fetched, and left out until they arrive.
 */
const useParticipantProfiles = (
	userIds: UserId[]
): Record<UserId, UserProfile> => {
	useFetchMissingProfiles(userIds)
	const profiles = useProfilesFor(userIds)
	return useMemo(() => keyBy(compact(profiles), 'id'), [profiles])
}

export default useParticipantProfiles
